export const enum DomainEvents {
	repositoryWidgetAdded = "repositoryWidgetAdded",
}
